import React, { useState, useEffect } from 'react';
import { getFirestore, collection, getDocs } from 'firebase/firestore';
import './Actualites.css';
import { Article } from '../types';

function Actualites() {
  const [articles, setArticles] = useState<Article[]>([]);
  const [expandedArticle, setExpandedArticle] = useState<string | null>(null);

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const db = getFirestore();
        const articlesSnapshot = await getDocs(collection(db, 'Articles'));
        const articlesData = articlesSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        } as Article));
        
        const sortedArticles = articlesData.sort((a, b) => {
          return new Date(b.dateCreation?.toDate() || 0).getTime() - 
                 new Date(a.dateCreation?.toDate() || 0).getTime();
        });
        
        setArticles(sortedArticles);
      } catch (error) {
        console.error('Erreur lors de la récupération des articles:', error);
      }
    };

    fetchArticles();
  }, []);

  return (
    <div className="actualites-container">
      <h1>Actualités</h1>
      {articles.map((article) => (
        <section key={article.id} className="content-section">
          <div className="section-title">{article.titre}</div>
          <div className="content-wrapper">
            {article.image && article.positionImage === 'gauche' && (
              <div className="image-zone">
                <img src={article.image} alt={article.titre} />
              </div>
            )}
            <div className="text-zone">
              <p dangerouslySetInnerHTML={{
                __html: expandedArticle === article.id ? article.contenuComplet : article.resume
              }} className="article-content" />
              <button
                onClick={() => setExpandedArticle(expandedArticle === article.id ? null : article.id)}
                className="lire-suite-btn"
              >
                {expandedArticle === article.id ? 'Réduire' : 'Lire la suite'}
              </button>
            </div>
            {article.image && article.positionImage === 'droite' && (
              <div className="image-zone">
                <img src={article.image} alt={article.titre} />
              </div>
            )}
          </div>
        </section>
      ))}
    </div>
  );
}

export default Actualites;